import { CanActivateFn } from '@angular/router';
import * as AuthActions from '../store/actions/auth.actions';
import * as fromAuth from '../store/reducers/auth.reducers';
import * as fromApp from '../store/app.state';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { map, take } from 'rxjs';

export const adminGuard: CanActivateFn = (route, state) => {
  const store = inject(Store<fromApp.AppState>);
  return store.select('auth').pipe(
    take(1),
    map((authState: fromAuth.State) => {
      const isAuthorized = authState.isAuthenticated
        && (authState?.user?.isOrgAdmin || authState?.user?.isOrgUser)
        && (authState.loggedInModule == 'orgAdmin' || authState.loggedInModule == 'orgUser');

      console.warn(`[adminGuard] route: ${state.url}, isAuthorized: ${isAuthorized}, isAuthenticated: ${authState.isAuthenticated}, refreshInProgress: ${authState.refreshTokenInProgress}, user: ${!!authState.user}, loggedInModule: ${authState.loggedInModule}`);

      if (!isAuthorized) {
        console.warn(`[adminGuard] DENIED for ${state.url}. Stack:`, new Error().stack);
        store.dispatch(AuthActions.unAuthorized());
        return false;
      }
      return true;
    })
  );
};
